exports = module.exports = require("./../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".giga-grid .giga-grid-toolbar {\n  padding-left: 5px;\n}\n.giga-grid-sortable {\n  border: 1px solid toolbar-border-color;\n  padding: 1em;\n}\n.giga-grid-flex-column {\n  float: left;\n  padding: 10px;\n}\n.giga-grid-flex-column.column-50 {\n  width: 50%;\n}\n.giga-grid-flex-column.column-100 {\n  width: 100%;\n}\ninput.giga-grid-text-input {\n  padding: 10px 10px 10px 5px;\n  border: none;\n  border-bottom: 2px solid #757575;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./~/giga-grid/src/components/toolbar/Toolbar.styl
 ** module id = 461
 ** module chunks = 0
 **/